import type { FC } from "react";
import { useTranslation } from "react-i18next";
import SystemDialog from "../../../components/UIToolkit/Popups/Dialog";

type Props = {
	open: boolean;
	/** The earlier version being restored. */
	versionNumber: number;
	isRestoring: boolean;
	onConfirm: () => void;
	onClose: () => void;
};

/**
 * Confirms restoring an earlier version: a copy of it comes back as a new current version, and every later one is
 * kept. The copy's number isn't promised here (the server numbers it, and a colleague may save first); the success
 * toast names it.
 */
export const CustomPrintoutRestoreDialog: FC<Props> = ({ open, versionNumber, isRestoring, onConfirm, onClose }) => {
	const { t } = useTranslation();
	return (
		<SystemDialog
			open={open}
			onClose={onClose}
			title={t("printout.custom.ai.version.restore.title", { number: versionNumber })}
			body={t("printout.custom.ai.version.restore.body")}
			confirm={t("printout.custom.ai.version.restore.confirm", { number: versionNumber })}
			cancel={t("cancel")}
			onConfirm={onConfirm}
			confirmLoading={isRestoring}
			confirmDisabled={isRestoring}
			dataTestId="custom-printout-restore-dialog"
			confirmDataTestId="custom-printout-restore-confirm"
			cancelDataTestId="custom-printout-restore-cancel"
		/>
	);
};
